import ReactGA from 'react-ga';
const TRACKING_ID =  process.env.NODE_ENV === 'production' ? 'UA-35583129-1' : 'UA-35583129-4'

const sendWhoIsAccessing = (userEmail) => {
  ReactGA.initialize(TRACKING_ID)
  var ga = ReactGA.ga()
  ga('send', 'event', 'Login', 'Login Success', window.location.origin, {
    dimension1 : userEmail,
    dimension2 : window.location.origin
  })
}

const fireTracking = () => {
    ReactGA.initialize(TRACKING_ID)
    ReactGA.pageview(window.location.pathname + window.location.search);
}

const sendEvent = (action, label) => {
  ReactGA.initialize(TRACKING_ID)
  ReactGA.event({
    category: 'Lunch Feedback',
    action,
    label
  })
}

// Sign-in funnel events. Fixed names only: never pass an email, token or user id.
export const SIGN_IN_EVENTS = {
  MAGIC_LINK_REQUESTED: 'magic_link_requested',
  MAGIC_LINK_SIGNED_IN: 'magic_link_signed_in',
  PASSWORD_FALLBACK_CLICKED: 'password_fallback_clicked',
}

const sendSignInEvent = (action, label) => {
  try {
    ReactGA.initialize(TRACKING_ID)
    ReactGA.event(label ? { category: 'Sign In', action, label } : { category: 'Sign In', action })
  } catch (error) {
    // Analytics must never break sign-in.
  }
}

export default {
  fireTracking,
  sendWhoIsAccessing,
  sendEvent,
  sendSignInEvent
}



// WEBPACK FOOTER //
// ./src/utils/googleAnalytics.js